/** Canonical pure PHP 8 compatibility for Janus transliterations.
 * A port clones every array it receives before mutating it, exactly where PHP's
 * copy-on-write would have copied. Use phpCopy; never rely on JS assignment.
 * Safe integral JS numbers are PHP ints, other numbers are doubles; PhpFloat
 * preserves integral doubles. bigint preserves exact signed 64-bit integers.
 * Plain objects represent PHP associative arrays, not native PHP class instances.
 * No bundle entry imports this module during the unwired S0 build phase.
 */
export * from './values';
export * from './ordered-array';
export * from './arrays';
export * from './json';
export * from './strings';
